import { Card } from "@/components/ui/card";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import { Mail, Phone, UserRound } from "lucide-react";

export function PayrollManagerCard({ pm }) {
  return (
    <Card className="p-5 relative overflow-hidden" data-testid="payroll-manager-card">
      <div className="absolute -right-8 -top-8 w-32 h-32 rounded-full bg-primary/10" />
      <div className="text-xs font-semibold uppercase tracking-wide text-primary mb-3">Your Payroll Manager</div>
      {pm ? (
        <div className="flex items-center gap-4">
          <Avatar className="w-16 h-16 border-2 border-primary/30"><AvatarImage src={pm.avatar} /><AvatarFallback>{pm.name?.[0]}</AvatarFallback></Avatar>
          <div className="min-w-0">
            <div className="font-display font-bold text-lg" data-testid="pm-name">{pm.name}</div>
            <div className="text-xs text-muted-foreground">{pm.title}</div>
            <a data-testid="pm-email" href={`mailto:${pm.email}`} className="mt-1.5 flex items-center gap-1.5 text-sm hover:text-primary truncate"><Mail className="w-3.5 h-3.5" /> {pm.email}</a>
            {pm.phone && <a data-testid="pm-phone" href={`tel:${pm.phone}`} className="flex items-center gap-1.5 text-sm hover:text-primary"><Phone className="w-3.5 h-3.5" /> {formatPhone(pm.phone)}</a>}
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-3 text-muted-foreground text-sm"><UserRound className="w-5 h-5" /> No payroll manager assigned yet.</div>
      )}
    </Card>
  );
}
